var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostError',[_c('p',{staticClass:"page-email-activation-main"},[_vm._v(" 404~找不到呀找不到~ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }